import React, { Component } from "react";

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

let scriptPromise = null;

// Loads Google reCAPTCHA v2 once for the whole app and resolves with grecaptcha.
function loadRecaptcha() {
  if (window.grecaptcha && window.grecaptcha.render) {
    return Promise.resolve(window.grecaptcha);
  }
  if (scriptPromise) return scriptPromise;

  scriptPromise = new Promise((resolve, reject) => {
    window.__onRecaptchaLoaded = () => resolve(window.grecaptcha);
    const script = document.createElement("script");
    script.src =
      "https://www.google.com/recaptcha/api.js?onload=__onRecaptchaLoaded&render=explicit";
    script.async = true;
    script.defer = true;
    script.onerror = () => {
      scriptPromise = null;
      reject(new Error("Unable to load reCAPTCHA"));
    };
    document.head.appendChild(script);
  });

  return scriptPromise;
}

class Recaptcha extends Component {
  constructor(props) {
    super(props);
    this.container = React.createRef();
    this.widgetId = null;
    this.state = { loadFailed: false };
  }

  componentDidMount() {
    if (!SITE_KEY) {
      console.error(
        "REACT_APP_RECAPTCHA_SITE_KEY is missing. Add it to .env and restart " +
          "the dev server — Create React App only reads .env at startup."
      );
      this.setState({ loadFailed: true });
      return;
    }

    loadRecaptcha()
      .then((grecaptcha) => {
        if (!this.container.current || this.widgetId !== null) return;
        this.widgetId = grecaptcha.render(this.container.current, {
          sitekey: SITE_KEY,
          theme: this.props.theme || "light",
          callback: (token) => this.props.onChange(token),
          "expired-callback": () => this.props.onChange(null),
          "error-callback": () => this.props.onChange(null),
        });
      })
      .catch((error) => {
        console.error("reCAPTCHA failed to initialise:", error);
        this.setState({ loadFailed: true });
      });
  }

  // Called by the parent after a failed submit — a token can only be used once.
  reset() {
    if (this.widgetId !== null && window.grecaptcha) {
      window.grecaptcha.reset(this.widgetId);
    }
    this.props.onChange(null);
  }

  render() {
    return (
      <div className="recaptcha-wrapper">
        <div ref={this.container}></div>
        {this.state.loadFailed && (
          <p className="recaptcha-error">
            Verification could not be loaded. Please refresh the page and try
            again.
          </p>
        )}
      </div>
    );
  }
}

export default Recaptcha;
